export function getButton(props, listener) {
  /*
    props =
      text, outer_style, inner_style, text_class, listener
  */
  if (props.text === undefined) { props.text = ''; }
  if (props.outer_style === undefined) { props.outer_style = {}; }
  if (props.text_class === undefined) { props.text_class = ''; }
  if (props.inner_style === undefined) { props.inner_style = {}; }
  if (props.disabled === undefined) { props.disabled = false; }
  if (props.disabled) {
    props.text_class += ' crs_default';
  } else {
    props.text_class += ' crs_pointer';
  }
  if (listener === undefined) { listener = null; }
  return (
    <div id={props.id} style={{...m_style.outer, ...props.outer_style}}>
      <div
        className={props.text_class}
        disabled={props.disabled}
        style={{...m_style.inner, ...props.inner_style}}
        onClick={() => {if(listener !== null && !props.disabled) {listener();}}}
      >
        <span>{props.text}</span>
      </div>
    </div>
  );
}

const m_style = {
  outer : { height : 40, display : 'flex', flexDirection : 'column' },
  inner : { display : 'flex', flex : 1, paddingLeft : 10, paddingRight : 10, justifyContent : 'center', alignItems : 'center' }
}
